module.exports = __webpack_public_path__ + "img/cooperate_32.3c7080ad.jpg";